import { render } from "./CheckMarkBlack.vue?vue&type=template&id=8e56447a"
import script from "./CheckMarkBlack.vue?vue&type=script&lang=js"
export * from "./CheckMarkBlack.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__